const colors = {
	backgroundBlue: "#0B3192",
	btnGreen: "#00CC8F",
	offWhite: "#F7F9FE",
};

export default colors;
